import React from "react";
import { useOverrideProjectFolderSyncMutation } from "../mutations.hotchoc.generated";
import { useSnackBar } from "~/components/snackbar";
import { useProjectFoldersPageApi } from "../ProjectFoldersPageApi";
import { OverrideSyncButtons } from "../components/OverrideSyncButtons";
import { ProjectFolder } from "../types";
import { handleResult } from "../utils";

type OverrideProjectFolderSyncProps = {
  folder: ProjectFolder;
};

export const OverrideProjectFolderSync: React.FC<
  OverrideProjectFolderSyncProps
> = ({ folder }) => {
  const addAlert = useSnackBar();
  const { reload } = useProjectFoldersPageApi();
  const [handleOverride, { loading }] = useOverrideProjectFolderSyncMutation();

  const handle = async (retry: boolean) => {
    const variables = {
      input: {
        name: folder.name,
        projectNumber: folder.projectId,
        retrySync: retry,
      },
    };

    const response = await handleOverride({ variables });

    const errors = handleResult(
      response!.data!.projectFolders!.overrideProjectFolderSync
    );

    if (errors) {
      addAlert({
        key: `failed-sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: errors,
        isSuccess: false,
      });
    } else {
      addAlert({
        key: `sync-folder-${folder.__typename}-${folder.fullPath}`,
        message: `"${folder.name}" ${
          retry ? "queued for sync retry" : "sync status overridden"
        }`,
        isSuccess: true,
      });

      reload();
    }
  };

  return <OverrideSyncButtons loading={loading} handle={handle} />;
};
